import { stringify } from "query-string";

import { Country } from "@libs/enums/country.enum.ts";
import { routes } from "@libs/routing/routes.ts";
import { ApplyToDateKeys } from "@modules/billing/screens/acc-invoices/components/AccInvoiceTransactionsListFilter.types.ts";
import { useDraftRoute } from "@modules/billing/screens/draft-items/hooks/useDraftRoute.ts";
import { NavLink } from "@ui-components/navigation/Nav.tsx";

import { useNewInvoiceLink } from "./useNewInvoiceLink.ts";
import { useNewPaymentLink } from "./useNewPaymentLink.ts";

export const useFinanceLinks = (): NavLink[] => {
  const goToDrafts = useDraftRoute();

  return [
    useNewInvoiceLink(),
    useNewPaymentLink(),
    {
      name: "Find an ACC claim",
      path: routes.claims.basePath,
      tenantLocation: Country.NewZealand,
      showBorder: true
    },
    {
      name: "General accounts",
      path: routes.accounts.basePath
    },
    {
      name: "ACC billing",
      path: routes.accounts.accInvoices.basePath,
      tenantLocation: Country.NewZealand
    },
    {
      name: "Accredited billing",
      url: `${routes.accounts.accreditedBilling.basePath.path({})}?${stringify({
        applyToDate: ApplyToDateKeys.transactionDate
      })}`,
      permissions: routes.accounts.accreditedBilling.basePath.permissions,
      tenantLocation: Country.NewZealand
    },
    {
      name: "Draft items",
      path: routes.accounts.draftItems.basePath,
      onClick: goToDrafts,
      tenantLocation: Country.NewZealand
    },
    {
      name: "Statements",
      path: routes.accounts.statements.basePath
    }
  ];
};
